import React from 'react';
import '../../styles/SolucionesPublicitarias.css';
import cardsData from '../../data/displayDesktop.json';


const DisplayDesktop = () => {
    return (
        <section className="display-desktop-section py-5">
            <div className="container">

                <div className="title-container" data-aos="fade-up">
                    <h2 className="title">Desktop</h2>
                    <div className="title-underline"></div>
                </div>

                <div className='row align-items-center'>
                    {cardsData.map((card, index) => (
                        <div
                            key={index}
                            className='col-lg-6 col-md-6 display-desktop-card justify-content-center align-items-center mt-4'
                        >
                            <div className='img-display-desktop' data-aos="flip-right">
                                <img src={card.img} className='img-fluid img-filter' alt={card.title} />
                            </div>
                            <div data-aos="fade-up">
                                <h4 >{card.title}</h4>
                                <p >{card.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DisplayDesktop;